import {
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Col, Divider, Flex, Image, Layout, Radio, Row, Space, Upload } from "antd";
import { useEffect, useState } from "react";

import { Alert } from "components/elements";
// import { FormDatePicker, Input, RadioGroup, Select } from "components/form";

import { useTranslation } from "react-i18next";
import {
  initialValues as INITIAL_VALUES,
  NATIONALITY,
} from "../schemas/employeeCreateSchema";
import styles from "../styles/EmployeeForm.module.css";
// import { Content } from "antd/es/layout/layout";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormInputIdentification, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { requestIdCard } from "utils/formatter/formatCommon";
import { dataURLtoFile } from "utils/helper";
import * as service from "../services/employeeApi";
import { formatDate } from "utils/formatter";
const { Content, Footer } = Layout;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  return false;
};

const EmployeeForm = ({
  initialValues = {},
  titleNameOptions = [],
  titleNameEnOptions = [],
  employeeTypeOptions = [],
  countryOptions = {},
  visaTypeOptions = {},
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [isFileMax, setIsFileMax] = useState(false)
  const [formUse] = useForm();


  useEffect(() => {
    if (isFileMax) {
      Alert({ message: 'maximum file size is 2Mb', type: "error" });
    }
  }, [isFileMax]);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("common.upload")}
      </div>

    </button>
  );

  useEffect(() => {
    if (initialValues.avatar) {
      setLoading(true);
      getBase64(initialValues.avatar, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.avatar]);

  return (
    <>
      <FormAntd
        initialValues={INITIAL_VALUES}
        onFinish={onSubmit}
        form={formUse}
      >
        <FormItem shouldUpdate={(prev, curv) => {
          return prev['employeeNationality'] != curv['employeeNationality'] ||
            prev['taxId'] != curv['taxId'] || prev['passportNo'] != curv['passportNo']
        }}>
          {/* {({ values = {}, setFieldValue = () => { }, setTouched = () => { } }) => { */}
          {({ getFieldValue, setFieldValue, resetForm }) => {
            const onAvatarChange = async (info) => {
              setLoading(true);
              const compressImg = await service.compressedImage({
                file: info.file
              })
              getBase64(compressImg.data, (url) => {
                console.log("url2 ", url);
                setLoading(false);
                setFieldValue("avatar", dataURLtoFile(url));
                setImageUrl(url);
              });
            };

            const onClearAvatar = (e) => {
              e.stopPropagation();
              setFieldValue("avatar", null);
              setLoading(false);
              setImageUrl(null);
            };

            return (
              // <Form>
              <Layout>
                <Row >
                  <Flex style={{ textAlign: "center" }}>
                    <Upload
                      name="avatar"
                      listType="picture-circle"
                      className={styles.avatarUploader}
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={onAvatarChange}
                      action={null}
                    >
                      {imageUrl ? (
                        <Col style={{
                          padding: 0
                        }}>
                          <Image preview={false}
                            src={imageUrl}
                            alt="avatar"
                            className={styles.avatar}
                            style={{
                              width: "100%",
                            }}
                          >
                          </Image>
                          <MinusCircleOutlined
                            style={{
                              bottom: 0,
                              right: 0,
                              zIndex: 999
                            }}
                            className={styles.avatarMinusIcon}
                            onClick={onClearAvatar}
                          />
                        </Col>
                      ) : (
                        uploadButton
                      )}
                    </Upload>
                  </Flex>
                  <Content style={{ paddingLeft: "3vw", paddingRight: 0 }}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <FormInput
                          name="employeeNo"
                          label={
                            t("employee.label.employee_no")
                          }
                          placeholder={
                            t("employee.label.employee_no")
                          }
                          size="large"
                        />
                      </Col>
                      <Col span={12}>
                        <FormInput
                          required={true}
                          name="email"
                          label={
                            t("employee.label.email")
                          }
                          placeholder={
                            t("employee.label.email") +
                            t("common.required_field_suffix")

                          }
                          size="large"
                        />
                      </Col>
                    </Row>
                    <Row gutter={24} style={{ paddingTop: "3vh" }}>
                      <Col span={8}>
                        <FormSelect
                          required={true}
                          name="titleId"
                          label={
                            t("employee.label.title_th")
                          }
                          placeholder={
                            t("employee.label.title_th") + t("common.required_field_suffix")
                          }
                          size="large"
                          options={titleNameOptions}
                        />
                      </Col>
                      <Col span={8}>
                        <FormInput
                          required={true}
                          name="name"
                          label={t('employee.label.name_th')}
                          placeholder={t('employee.label.name_th') + t("common.required_field_suffix")}
                          size="large"
                        />
                      </Col>
                      <Col span={8}>
                        <FormInput
                          required={true}
                          name="surName"
                          label={t('employee.surname-th')}
                          placeholder={t('employee.surname-th') + t("common.required_field_suffix")}
                          size="large"
                        />
                      </Col>
                    </Row>
                    <Row gutter={24} style={{ paddingTop: "3vh" }}>
                      <Col span={8}>
                        <FormSelect
                          required={true}
                          name="titleId"
                          label={
                            t("employee.label.title_en")
                          }
                          placeholder={
                            t("employee.label.title_en") + t("common.required_field_suffix")
                          }
                          size="large"
                          options={titleNameEnOptions}
                        />
                      </Col>
                      <Col span={8}>
                        <FormInput
                          required={true}
                          name="nameEn"
                          label={
                            t("employee.label.name_en")
                          }
                          placeholder={
                            t("employee.label.name_en") + t("common.required_field_suffix")
                          }
                          size="large"
                        />
                      </Col>
                      <Col span={8}>
                        <FormInput
                          required={true}
                          name="surNameEn"
                          label={
                            t("employee.label.surname_en")
                          }
                          placeholder={
                            t("employee.label.surname_en") + t("common.required_field_suffix")
                          }
                          size="large"
                        />
                      </Col>
                    </Row>
                    <Row gutter={24} style={{ paddingTop: "3vh" }}>
                      <Col span={8}>
                        <FormSelect
                          required={true}
                          name="employeeTypeId"
                          label={
                            t("employee.label.type")
                          }
                          placeholder={t('common.pleaseSelect')}
                          size="large"
                          options={employeeTypeOptions}
                        />
                      </Col>
                      <Col span={8}>
                        <FormSelect
                          required
                          tree={true}
                          name="departmentId"
                          label={t("employee.label.department")}
                          placeholder={t("common.pleaseSelect")}
                          size="large"
                          options={organizationUnderOptions}
                          onChange={(e) => {
                            console.log("departmentOptions", e);
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <FormSelect
                          tree={true}
                          required
                          name="positionId"
                          label={t("employee.label.position")}
                          placeholder={t("common.pleaseSelect")}
                          size="large"
                          options={modifiedPositionOptions}
                          onChange={(e) => {
                            console.log("positionOptions", e);
                          }}
                        />
                      </Col>
                    </Row>
                    <Divider className={styles.customDivider} />
                    <Row gutter={24}>
                      <Col span={24}>
                        <Radio.Group
                          required={true}
                          name="employeeNationality"
                          label={
                            t("employee.label.employee_nationality")
                          }
                          defaultValue={getFieldValue("employeeNationality")}
                          onChange={(e) => {
                            setFieldValue("employeeNationality", e.target.value)
                          }}
                          options={[
                            {
                              label: t("employee.label.domestic"),
                              value: NATIONALITY.DOMESTIC,
                            },
                            {
                              label: t("employee.label.foreigner"),
                              value: NATIONALITY.FOREIGNER,
                            },
                          ]}
                        // onChange={() => {
                        //   setTouched({}, false);
                        // }}
                        />
                      </Col>
                      <Col span={12} style={{ paddingTop: "3vh" }}>
                        <FormInputIdentification
                          required={true}
                          name="taxId"
                          label={
                            getFieldValue("employeeNationality") === NATIONALITY.DOMESTIC
                              ? t("employee.label.identification_id")
                              : t("employee.label.tax_id")
                          }
                          placeholder={
                            getFieldValue("employeeNationality") === NATIONALITY.DOMESTIC
                              ? t("employee.label.identification_id") + t("common.required_field_suffix")
                              : t("employee.label.tax_id") + t("common.required_field_suffix")
                          }
                          size="large"
                          maxLength={17}
                          form={formUse}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (value && requestIdCard(value).length !== 13) {
                                  if (getFieldValue("employeeNationality") === NATIONALITY.DOMESTIC) {
                                    return Promise.reject(new Error(t('employee.error.req_thirteen')));
                                  } else {
                                    return Promise.reject(new Error(t('employee.error.req_thirteen_tax')));
                                  }
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        />
                      </Col>
                    </Row>
                    {getFieldValue("employeeNationality") === NATIONALITY.FOREIGNER ? (
                      <Content>
                        {/* --- Passport --- */}
                        <Row gutter={16} style={{ paddingTop: "3vh" }}>
                          <Col span={6}>
                            <FormInput
                              name="passportNo"
                              label={t('employment-information.label.passportNo')}
                              placeholder={t('employment-information.label.passportNo')}
                              size="large"
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <FormSelect
                              name="passportIssueCountryId"
                              label={t('employment-information.label.passportIssueCountry')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={countryOptions}
                              required
                            />
                          </Col>
                          <Col span={6}>
                            <FormDatePicker
                              name="passportIssueDate"
                              label={t('employment-information.label.passportIssueDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                            />
                          </Col>
                          <Col span={6}>
                            <FormDatePicker
                              name="passportExpireDate"
                              label={t('employment-information.label.passportExpireDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                              required
                            />
                          </Col>
                        </Row>

                        {/* --- Visa --- */}
                        <Row gutter={16} style={{ paddingTop: "3vh" }}>
                          <Col flex="20%">
                            <FormSelect
                              name="visaTypeId"
                              label={t('employment-information.label.visaType')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={visaTypeOptions}
                            // required
                            />
                          </Col>
                          <Col flex="20%">
                            <FormInput
                              name="visaNo"
                              label={t('employment-information.label.visaNo')}
                              placeholder={t('employment-information.label.visaNo')}
                              size="large"
                            // required
                            />
                          </Col>
                          <Col flex="20%">
                            <FormSelect
                              name="visaIssueCountryId"
                              label={t('employment-information.label.visaIssueCountry')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={countryOptions}
                            // required
                            />
                          </Col>
                          <Col flex="20%">
                            <FormDatePicker
                              name="visaIssueDate"
                              label={t('employment-information.label.visaIssueDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                            />
                          </Col>
                          <Col flex="20%">
                            <FormDatePicker
                              name="visaExpireDate"
                              label={t('employment-information.label.visaExpireDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                            // required
                            />
                          </Col>
                        </Row>

                        {/* --- Work Permit --- */}
                        <Row gutter={16} style={{ paddingTop: "3vh" }}>
                          <Col span={8}>
                            <FormInput
                              name="workPermitNo"
                              label={t('employment-information.label.workPermitNo')}
                              placeholder={t('employment-information.label.workPermitNo')}
                              size="large"
                            // required
                            />
                          </Col>
                          <Col span={8}>
                            <FormDatePicker
                              name="workPermitIssueDate"
                              label={t('employment-information.label.workPermitIssueDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                            />
                          </Col>
                          <Col span={8}>
                            <FormDatePicker
                              name="workPermitExpireDate"
                              label={t('employment-information.label.workPermitExpireDate')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              format={formatDate()}
                            // required
                            />
                          </Col>
                        </Row>
                      </Content>
                    ) : (
                      <></>
                    )}

                    <Row justify="end" style={{ paddingTop: "3vh" }}>
                      <Space size={12}>
                        <Button type="default" size="large" onClick={onCancel} style={{ borderRadius: "8px" }}>
                          {t("common.cancel")}
                        </Button>
                        <Button type="primary" size="large" htmlType="submit" style={{ borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                          {t("confirm")}
                        </Button>
                      </Space>
                    </Row>
                  </Content>
                </Row>
              </Layout>
              // </Form>
            );
          }}
        </FormItem>
      </FormAntd>
    </>
  );
};

export default EmployeeForm;
